<app-pdf-page>
    <app-pdf-page-header>{{ pdfDetails.projectDetails.name }}</app-pdf-page-header>
    <h1 class="pdf-page__project-title">{{ 'PAGE_FILL_TIS_QUICKSCAN.title' | translate : { tisLabelShort: pdfDetails.projectDetails.projectInfo.tisLabelShort } }}</h1>
    <small>{{ 'PAGE_FILL_QUICKSCAN.version' | translate }}: {{ pdfDetails.quickscanDefinition?.versionId }}</small>

    <div class="grid-spacer grid-spacer--large"></div>
    <app-pdf-page-quickscan-list
        [quickscanDefinition]="pdfDetails.quickscanDefinition"
        [quickscanAnswers]="pdfDetails.projectDetails.tisQuickscanAnswers"
        [categoryInfo]="pdfDetails.projectDetails.categoryInfo"
    >
    </app-pdf-page-quickscan-list>

    <app-pdf-page-footer><app-classification></app-classification></app-pdf-page-footer>
</app-pdf-page>
<app-pdf-pagebreak></app-pdf-pagebreak>
<app-pdf-page-quickscan-result
    [pdfDetails]="pdfDetails"
    [quickscanResult]="pdfDetails.tisQuickscanResult"
    [quickscanDefinition]="pdfDetails.quickscanDefinition"
    [tis]="true"
>
</app-pdf-page-quickscan-result>
